import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { relationshipScoreQueryLinkerSchema } from './relationship-score-query-linker-schema';

export const relationshipScoreQuerySchema = z.object({
  ...relationshipScoreQueryLinkerSchema.shape,
  number: z.string(), // "1", "2", "3", "4", "5"
  status: statusQuerySchema,
  clients_count: z.number(),
});

export type RelationshipScoreQuerySchema = z.infer<typeof relationshipScoreQuerySchema>;

export const relationshipScoreQueryAllSchema = paginatedResponseSchema(relationshipScoreQuerySchema);
export type RelationshipScoreQueryAllSchema = z.infer<typeof relationshipScoreQueryAllSchema>;
